import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, mapTo } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { Details } from '@details/Interfaces/details';
import { Field as Field } from '@common/models/field-definition';
import { SaveDetailsWidgetConfigurationRequest } from '@common/models/save-creditor-details-widget-configuration-request';

@Injectable({
  providedIn: 'root'
})
export class CreditorDetailsHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlProvider: UrlBuilderService) { }

  getCreditorDetails(widgetConfigId: number, creditorUri: number): Observable<Details> {
    const url = this.urlProvider.getUrl(`creditordetails/${widgetConfigId}/${creditorUri}`);
    return this.http.get<Details>(url);
  }

  getFields(widgetConfigId: number): Observable<Field[]> {
    const url = this.urlProvider.getUrl(`creditordetails/${widgetConfigId}/fields`);
    return this.http.get<Field[]>(url).pipe(
      map(details => details || undefined)
    );
  }

  createCopyOfConfiguration(config: SaveDetailsWidgetConfigurationRequest): Observable<boolean> {
    const url = this.urlProvider.getUrl('creditordetails/config/copy');
    return this.http.post(url, config).pipe(mapTo(true));
  }

  saveConfiguration(config: SaveDetailsWidgetConfigurationRequest): Observable<boolean> {
    const url = this.urlProvider.getUrl('creditordetails/config');
    return this.http.post(url, config).pipe(mapTo(true));
  }
}
